import { DefaultRecordValueConfigTablePanel } from "#batteries-included-components/Panels/TablePanels/DefaultRecordValueConfigTablePanel";
import { RecordsTablePanel } from "#src/batteries-included-components";
import { ApplyAutomationProgressBanner } from "#src/batteries-included-components/Banners/ApplyAutomationProgressBanner";
import { RecordsViewFilterArea } from "#src/batteries-included-components/FilterAreas/RecordsFilterAreas";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { ButtonToggleGroup } from "@validereinc/common-components";
import { AssetType } from "@validereinc/domain";
import React, { useState } from "react";
import { FlowUpdateStatusBanner } from "./FlowUpdateStatusBanner";

export const FlowRecordsTab = ({ flowId }: { flowId: string }) => {
  const [filterConfigStorageKey, viewConfigStorageKey] = useStorageKey(
    ["filter-configuration", "view-configuration"],
    ["records", "list", "flows"]
  );
  const [tableConfigStorageKey, tableStateStorageKey] = useStorageKey(
    ["table-configuration", "table-state"],
    ["records", "list", "flows", flowId]
  );
  const [applySeededAutomationJobStorageKey] = useStorageKey(
    ["async-job"],
    "flow-seeded-automation-job-configuration"
  );
  const [drvcTableConfigStorageKey, drvcTableStateStorageKey] = useStorageKey(
    ["table-configuration", "table-state"],
    ["records", "default-record-value-configuration", "list", "flows"]
  );
  const [mode, setMode] = useState<"records" | "automation">("records");

  return (
    <>
      <FlowUpdateStatusBanner />
      <div
        style={{
          marginRight: 8,
          display: "flex",
          gap: 8,
          marginBottom: 16,
          alignItems: "center",
        }}
      >
        <ButtonToggleGroup
          activeKey={mode}
          items={[
            { label: "Records", dataKey: "records" },
            { label: "Default Automations", dataKey: "automation" },
          ]}
          onChange={(val) => setMode(val as "records" | "automation")}
          name="records-switcher"
        />
        <RecordsViewFilterArea
          viewConfigStorageKey={viewConfigStorageKey}
          isPeriodDateRange={true}
          isPeriodAvailable={mode === "records"}
        />
      </div>
      {mode === "records" && (
        <>
          <ApplyAutomationProgressBanner
            jobStorageKey={applySeededAutomationJobStorageKey}
            showCounts={false}
          />
          <RecordsTablePanel
            type={AssetType.FLOW}
            filterConfigStorageKey={filterConfigStorageKey}
            tableConfigStorageKey={tableConfigStorageKey}
            viewConfigStorageKey={viewConfigStorageKey}
            applySeededAutomationJobStorageKey={
              applySeededAutomationJobStorageKey
            }
            tableStateStorageKey={tableStateStorageKey}
          />
        </>
      )}
      {mode === "automation" && (
        <DefaultRecordValueConfigTablePanel
          type={AssetType.FLOW}
          tableConfigStorageKey={drvcTableConfigStorageKey}
          viewConfigStorageKey={viewConfigStorageKey}
          tableStateStorageKey={drvcTableStateStorageKey}
        />
      )}
    </>
  );
};
